// extracted by mini-css-extract-plugin
export default {"domain_padding":"PortalHeader_domain_padding__1slJA","padding_left":"PortalHeader_padding_left__2qzwX","pl":"PortalHeader_pl__zuYIs"};